import { stashDataSource } from '@/features/dataSources/dataSourcesSlice';
import { DataSource, DataSourceFileConfig } from '@/models/dataSource';
import { useAppDispatch, useAppSelector } from '@/reducers';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FileDataSourceRadioButton } from '../commons/FileDataSourceRadioButton/FileDataSourceRadioButton';
import { CSVTable } from '../commons/table';
import { StepPageActions } from '@/global/components';

const EVENT_BASED = 'EVENT';
const CUSTOMER_BASED = 'CUSTOMER';

type FileDataTypeProps = {
  onNextStep?: VoidFunction;
  onPrevStep?: VoidFunction;
  onCancel?: VoidFunction;
};

export const FileDataTypeStep: FC<FileDataTypeProps> = ({ onNextStep, onPrevStep }) => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation('data_source_edit');

  const csvFileData = useAppSelector((state) => state.fileUploading.fileData);
  const dataSource = useAppSelector((state) => state.dataSources.edit?.dataSource) as Partial<DataSource<DataSourceFileConfig>> | undefined;

  useEffect(() => {
    handleChangeDataType(dataSource?.configuration?.type || CUSTOMER_BASED);
  }, []);

  const handleChangeDataType = (value: Partial<DataSourceFileConfig['type']>) => {
    const dataSourceConfig = { ...dataSource?.configuration, type: value };
    dispatch(stashDataSource({ configuration: dataSourceConfig }));
  };

  return (
    <>
      <div className='flex flex-col justify-start gap-8'>
        <span className='text-sm font-semibold text-gray-700'>{t('file.data_type.type_of_data')}</span>

        <div className='flex-auto overflow-x-auto'>
          {csvFileData && <CSVTable fileContent={csvFileData.preview} fileHeaders={csvFileData.header} isDefaultHeaderCorrect={csvFileData.isDefaultHeader} />}
        </div>

        <div className='flex flex-col gap-2 '>
          <FileDataSourceRadioButton
            title={t('file.data_type.customer_based')}
            description={t('file.data_type.customer_based_description')}
            value={CUSTOMER_BASED}
            currentValue={dataSource?.configuration?.type || EVENT_BASED}
            onClick={() => handleChangeDataType(CUSTOMER_BASED)}
          />
          <FileDataSourceRadioButton
            title={t('file.data_type.event_based')}
            description={t('file.data_type.event_based_description')}
            value={EVENT_BASED}
            currentValue={dataSource?.configuration?.type || EVENT_BASED}
            onClick={() => handleChangeDataType(EVENT_BASED)}
          />
        </div>
      </div>

      <StepPageActions
        primaryButton={{
          text: 'COMMON:confirm',
          onClick: onNextStep,
        }}
        secondaryButton={{
          text: 'COMMON:cancel',
          onClick: onPrevStep,
        }}
      />
    </>
  );
};
